import { GenIcon } from '../helpers/IconBase.es.js';

const AtmCardColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M1.56455 3C0.699772 3 0 3.71097 0 4.58768V19.4116C0 20.2883 0.699772 21 1.56455 21H22.4347C23.2995 21 24 20.2883 24 19.4116V4.58768C24 3.71097 23.2995 3 22.4347 3H1.56455Z",
          fill: "#1D80C3"
        }
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18.7348 8.99997L17.2355 13.2538L15.7295 8.99997H14.1499V14.8647H15.3582V13.262L15.2375 10.4984L16.817 14.8647H17.6465L19.2306 10.4947L19.1091 13.262V14.8647H20.3219V8.99997H18.7348ZM8.68376 8.99997V9.97868H10.4561V14.8647H11.6643V9.97868H13.4614V8.99997H8.68376ZM5.1834 8.99997L2.99933 14.8647H4.28487L4.68763 13.6565H6.80645L7.21296 14.8647H8.4985L6.30318 8.99997H5.1834ZM5.74291 10.4819L6.48019 12.6778H5.01389L5.74291 10.4819Z",
          fill: "#FEFEFE"
        }
      }
    ]
  })(props);
};

export { AtmCardColored };
